<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="100px" :rules="rules" >
				<el-row>
						<el-col :span="12">
							<el-form-item label="客户手机号" prop="phone">
							<el-input v-model="formParameter.phone"  autocomplete="off" placeholder="请输入客户手机号">	</el-input></el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="客户姓名" prop="name">
							<el-input v-model="formParameter.name"  autocomplete="off" placeholder="请输入客户姓名">	</el-input></el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="开票时间" prop="kpdate">
								<el-date-picker
    						  	v-model="formParameter.kpdate"
								value-format="yyyy-MM-dd"
    						  	type="date"
    						  	placeholder="选择日期">
    							</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="合计金额" prop="cost"><el-input v-model="formParameter.cost" autocomplete="off"  ></el-input></el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="开票公司名" prop="sellname"><el-input v-model="formParameter.sellname" autocomplete="off" placeholder="有就填,不填视为开个人票"></el-input></el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="税号" prop="sellnum"><el-input v-model="formParameter.sellnum" autocomplete="off" placeholder="有就填"></el-input></el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="开票备注" prop="sname"><el-input v-model="formParameter.sname" autocomplete="off"></el-input></el-form-item>
						</el-col>
					</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">提交</el-button>
			<!-- <el-button @click="confirm1()">审批不合格</el-button> -->
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/xueli/fapiao.js';
import apiStu from '@/api/xueli/xlstudent.js';
export default {
	name: 'edit1',
	components: {
			popup
		},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			selected: [],
			formParameter: {},
			ids:[],
		    rules: {
				//手机
				phone: [
					{ required: true, message: '请输入', trigger: 'blur' },
					{ validator: this.validDh, message: '请输入正确的手机号格式', trigger: 'blur' }
				],
			 }
		};
	},
	methods: {
		validDh(rule, value, callback) {
			let dh = /^[1-9]\d{10}$/;
			if (dh.test(value)) {
				this.stuByKey(value.length);
				callback();
			} else {
				callback(new Error("手机号码不正确"));
			}
		},
		stuByKey(e) {
			//通过手机查回会员信息
			if (  e == 11) {
				apiStu.stuByKey({ key: this.formParameter.phone }, (response) => {
                    if(response.data){
						//自动回填 会员名称
						this.formParameter.name = response.data.name
						//$.set(this.formParameter,'name',response.data.name)
					}else{
						this.formParameter.name = '未找到'
						//$.set(this.formParameter,'name','未找到')
					}
					setTimeout(this.$forceUpdate(), 10);
				});
			}
		},
			//打开弹框
			open(payIds, title, disabled, size) {
			 
                if( payIds ){   // from 缴费记录
				 
					this.selected = payIds;
					this.ids = []
					this.formParameter.cost = 0
					payIds.forEach(v => {
			          	this.ids.push(v.id)
						//前端计算回显金额
					  	this.formParameter.cost+=v.cost*1
						if(!this.formParameter.name){   //循环中只执行1次
							this.formParameter.name =v.snm
							this.formParameter.phone =v.moblie
						}
			          });
			 
				}
				this.disabled = disabled;
				this.$refs.popup.open(title, size);
		 
			},
			//关闭弹框
			close() {
				this.disabled = false;
				this.$refs.popup.close();
			},
			//提交表单
			confirm() {
				this.$utils.checkForm(this.$refs.form, () => {
					this.confirmLoading = true;
						//添加
						let parameter = this.$utils.merger(this.formParameter);
						if(this.ids){
							parameter.ids = this.ids
						}
						api.mergeFP(parameter,
							response => {
								this.$utils.msg.success(response.msg);
								this.confirmLoading = false;
								this.close();
								this.$parent.list();
							},
							response => {
								this.$utils.msg.warning(response.msg);
								this.confirmLoading = false;
							}
						);
				});
			}
 
			 
		}
	};
</script>

<style lang="scss" scoped="scoped">
	@import '~common/custom/css/common.scss';
	@import '~common/custom/css/popup/popup.scss';
</style>
